import {EventCommentPost} from "../../types/domain.ts";
import {baseRequestService} from "../base.ts";

export const eventsEventIdCommentsPost = (eventId: string, data: EventCommentPost) => baseRequestService({
    url: `/events/${eventId}/comments`,
    method: 'POST',
    data
})